export default __webpack_public_path__ + "static/media/video.6f4a7281.mp4";